import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Widget } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-startpage',
  templateUrl: './startpage.component.html',
  styleUrls: ['./startpage.component.css']
})
export class StartpageComponent implements OnInit, OnDestroy {

  widgets: Widget[];
  widgetsReady: boolean = false;

  subscriptions: Subscription[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _dataService: DataService,
    private _changeRef: ChangeDetectorRef
  ) {
    this.subscriptions.push(this._route.queryParams.subscribe((params: Params) => {
      let setBgMode = params["setBackgroundMode"];
      if (setBgMode) this._dataService.setBackgroundAnchor.next(true);
      else this._dataService.setBackgroundAnchor.next(false);
    }));
  }

  ngOnDestroy(){
    for(let sub of this.subscriptions) sub.unsubscribe();
    this.subscriptions = [];
  }

  ngOnInit() {
    let callback = () => {
      this.widgets = this._dataService.startPage;
      this.widgetsReady = true;
    };
    if (this._dataService.startPageLoaded) {
      callback();
    } else {
      this.subscriptions.push(this._dataService.startPageLoadedAnchor.subscribe(() => {
        callback();
      }));
      if(!this._dataService.startPageLoading) this._dataService.loadStartpage();
    }
    this.subscriptions.push(this._dataService.startPageChanged.subscribe(() => {
      this.widgets = this._dataService.startPage;
      this._changeRef.detectChanges();
    }));
  }

  widgetAdded(result: Widget){
    this._dataService.startPage.push(result);
    this.widgets = this._dataService.startPage;
  }

  widgetDeleted(result: Widget){
    let i = this._dataService.startPage.indexOf(result);
    if(i > -1) {
      this._dataService.startPage.splice(i, 1);
      this.widgets = this._dataService.startPage;
    }
  }
}
